<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="v_tableData"
      :columns="tableColumns"
      :height="333"
      show-footer
      :footer-method="() => footerData"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="validRules"
      border
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ title }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="openChooseBookingVisible"
            v-if="!disabled"
          >
            <i class="el-icon-plus" />
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="batchDelShare()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            v-if="!disabled"
            @click="calCurrencyTotalAmount()"
            ><i class="el-icon-menu" />{{
              $l('form_label_one_click_allocation_amount') || '一键分摊金额'
            }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:depCode="{ row }">
        <dep-cascader
          size="small"
          ref="dep"
          :lastValue.sync="row.depCode"
          :valueString.sync="row.displayDepCode"
          :pathLabels.sync="row.orgDepFullName"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <BookingOptional
      :visible.sync="chooseBookingVisible"
      :custCode="custCode"
      :title="$l('dialog_title_choose_shipment_booking') || '选择订舱记录'"
      @confirm="chooseBookingConfirm"
    />
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { add, divideDown, multiplyDown, subtract } from '@/libs/util.number.js'
import BookingOptional from '../booking-optional'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { BookingOptional },
  mixins: [EditLoading],
  props: {
    title: {
      type: String,
      default: '',
    },
    shipmentExpenseCode: { type: String, default: '' },
    custCode: { type: String, default: '' },
    currencyTotalAmount: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.v_tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => totalColumnValues[t.field] || '')
      result[0] = '合计'
      return [result]
    },
  },
  data() {
    return {
      v_tableData: [],
      tableColumns: tableColumns(this),
      statementOptionalVisible: false,
      chooseBookingVisible: false,
      deleteRow: {},
      validRules: {
        orgDepFullName: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('INDEX.please_choose_item_label_orgDepFullName') ||
              '请选择分摊部门',
          },
        ],
      },
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e || []
      },
      immediate: true,
    },
  },
  methods: {
    async validate() {
      const data = this.getTableData()
      if (!data || !data.length) {
        this.$message({
          message:
            this.$l('tips_please_add_allocation_details') || '请添加分摊明细',
          type: 'warning',
        })
        return false
      }
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    batchDelShare() {
      this.$refs.itemTable.removeCheckboxRow()
      this.reassign()
    },
    del(row) {
      this.$refs.itemTable.remove(row)
      this.reassign()
    },
    openChooseBookingVisible() {
      if (!this.custCode) {
        this.$message.warning(
          this.$l('INDEX.form_label_please_select_a_customer') || '请选择客户'
        )
        return
      }
      this.chooseBookingVisible = true
    },
    chooseBookingConfirm(params) {
      var infos = params
        .map((t) => ({
          shipmentContractNo: t.contractNo,
          shipmentCode: t.shipmentCode,
          shipmentNo: t.shipmentNo,
          totalBookingVolume: t.totalBookingVolume,
          depCode: t.depCode,
          displayDepCode: t.displayDepCode,
          orgDepFullName: t.orgDepFullName,
          shareAmount: 0,
        }))
        .filter(
          (i) =>
            this.v_tableData.findIndex(
              (j) => j.shipmentContractNo === i.shipmentContractNo
            ) < 0
        )
      const $itemTable = this.$refs.itemTable
      infos.map(async (item) => {
        await $itemTable.insertAt({ ...item }, -1)
      })
      this.reassign()
    },
    //计算分摊金额
    calCurrencyTotalAmount() {
      this.reassign()

      //排序使用表格数据
      let sortTableData = this.getTableData().sort(
        (a, b) => b.totalBookingVolume - a.totalBookingVolume
      )
      if (!sortTableData || sortTableData.length === 0) return
      //计算总的订舱体积
      var allTotalBookingVolume = 0
      sortTableData.forEach(
        (i) =>
          (allTotalBookingVolume = add(
            allTotalBookingVolume,
            i.totalBookingVolume
          ))
      )
      var tableLength = sortTableData.length
      var currencyTotalAmountCopy = this.currencyTotalAmount
      sortTableData.forEach((row, index) => {
        row.shareAmount = multiplyDown(
          divideDown(row.totalBookingVolume, allTotalBookingVolume, 6),
          this.currencyTotalAmount,
          2
        )
        if (index + 1 != tableLength) {
          currencyTotalAmountCopy = subtract(
            currencyTotalAmountCopy,
            row.shareAmount
          )
        } else {
          row.shareAmount = currencyTotalAmountCopy
        }
      })

      sortTableData.forEach((i) => {
        const index = this.v_tableData.findIndex(
          (g) =>
            g.shipmentContractNo === i.shipmentContractNo &&
            g.shipmentNo === i.shipmentNo
        )
        this.v_tableData[index].shareAmount = i.shareAmount
      })
    },
    reassign() {
      this.v_tableData = this.getTableData()
    },
  },
}
</script>
